// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* This fix was necessary to ensure the ag-Grid container takes up the full width of its parent - especially after the introduction of primevue 4.5.5 and primeflex */\n.ag-root-wrapper { width:100%; }", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
